import { useCallback } from 'react';

import { useVideoGrid } from './use-video-grid';
import { isModifierOrMiddleClick } from '../utils/helper';
import { Clip, GridSize } from '../utils/types';

export interface ShowcasePlaylistHookProps {
  gridSize?: GridSize;
  isMobilePreview?: boolean;
  isShowcasePreview?: boolean;
  onVideoCardClick?: (
    link: string,
    clipId: string,
    videoPrivacy: string,
    userUri: string,
    live?: Clip['live'],
  ) => void;
  showVideoPlayerCards?: boolean;
}

/**
 * Hook for managing the showcase playlist layout and behavior.
 */
export const useShowcasePlaylist = ({
  gridSize,
  isMobilePreview,
  isShowcasePreview,
  onVideoCardClick,
  showVideoPlayerCards,
}: ShowcasePlaylistHookProps) => {
  const { effectiveGridSize, gridGap, numColumns } = useVideoGrid({
    gridSize,
    isMobilePreview,
    showVideoPlayerCards,
  });

  const handleVideoCardClick = useCallback(
    (e: React.MouseEvent<HTMLElement, MouseEvent>, clip: Clip) => {
      if (isModifierOrMiddleClick(e)) {
        return;
      }
      e.preventDefault();
      onVideoCardClick?.(
        isShowcasePreview ? clip.uri : clip.link,
        clip.clipId || '',
        clip.privacy.view,
        clip.user.uri,
        clip.live,
      );
    },
    [isShowcasePreview, onVideoCardClick],
  );

  return {
    direction: 'column' as const,
    effectiveGridSize,
    gridGap,
    handleVideoCardClick,
    numColumns,
  };
};
